/* Shopify's selling-plan select remains the submitted source of truth and no-JS fallback. */
class C4Purchase extends HTMLElement {
  connectedCallback() {
    this.abort = new AbortController();
    const product = this.closest('c4-product');
    const select = this.querySelector('[data-selling-plan]');
    const choices = this.querySelector('[data-purchase-choices]');
    const label = this.querySelector('[data-plan-label]');
    const summary = this.querySelector('[data-purchase-summary]');
    let remembered = '';
    const sync = () => {
      const options = [...select.options];
      const plans = options.filter((option) => option.value);
      const once = options.find((option) => !option.value);
      const subscribed = Boolean(select.value);
      choices.hidden = !plans.length;
      for (const button of choices.querySelectorAll('button')) {
        const active = (button.dataset.purchaseMode === 'subscribe') === subscribed;
        button.hidden = button.dataset.purchaseMode === 'once' && !once;
        button.setAttribute('aria-pressed', String(active));
        button.classList.toggle('button-secondary', !active);
      }
      if (once) once.hidden = true;
      plans.forEach((option) => {
        option.textContent = option.dataset.planName || option.textContent;
      });
      select.hidden = label.hidden = !subscribed;
      label.textContent = label.dataset.scheduleLabel;
      const chosen = select.selectedOptions[0];
      summary.hidden = !subscribed;
      summary.textContent = subscribed
        ? `${chosen.dataset.price} ${summary.dataset.perDelivery}${chosen.dataset.saving ? `, ${summary.dataset.savingLabel.toLowerCase()} ${chosen.dataset.saving}` : ''}`
        : '';
      if (subscribed) remembered = select.value;
    };
    this.addEventListener(
      'click',
      (event) => {
        const button = event.target.closest('[data-purchase-mode]');
        if (!button || select.disabled) return;
        select.value =
          button.dataset.purchaseMode === 'once'
            ? ''
            : [...select.options].find((option) => option.value && option.value === remembered)
                ?.value ||
              [...select.options].find((option) => option.value)?.value ||
              '';
        select.dispatchEvent(new Event('change', { bubbles: true }));
      },
      { signal: this.abort.signal },
    );
    product.addEventListener(
      'change',
      (event) => {
        if (event.target === select || event.target.matches('[data-variant]')) sync();
      },
      { signal: this.abort.signal },
    );
    sync();
  }
  disconnectedCallback() {
    this.abort?.abort();
  }
}
if (!customElements.get('c4-purchase')) customElements.define('c4-purchase', C4Purchase);
